
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2025/02/facebook-scams",
      function () {
        return require("private-next-pages/blog-post/2025/02/facebook-scams.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2025/02/facebook-scams"])
      });
    }
  